import { render, staticRenderFns } from "./payRecord.vue?vue&type=template&id=4836d941&"
import script from "./payRecord.vue?vue&type=script&lang=js&"
export * from "./payRecord.vue?vue&type=script&lang=js&"
import style0 from "./payRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports